module.exports = __webpack_public_path__ + "img/calcetto.ddca61f6.svg";